import moment from 'moment'
import checkinApi from '@/api/training/checkin'

const dateFormat = 'MMM D, YYYY HH:mm:ss A'
const dateLocale = 'en'

// initial state
const state = {
  attendanceCourses: []
}

// getters
const getters = {
  activeCourses: (state) => {
    return state.attendanceCourses.filter(course => {
      return !moment().isAfter(moment(course.endDate, dateFormat, dateLocale), 'date')
    })
  },
  inActiveCourses: (state) => {
    return state.attendanceCourses.filter(course => {
      return moment().isAfter(moment(course.endDate, dateFormat, dateLocale), 'date')
    })
  }
}

// actions
const actions = {
  getClassList ({ commit }) {
    return new Promise((resolve, reject) => {
      checkinApi.getClassList(resp => {
        if (resp.status === 0) {
          // console.log(resp.datas)
          commit('setAttendanceCourses', resp.datas)
          resolve()
        } else {
          reject(resp.msg)
        }
      })
    })
  }
}

// mutations
const mutations = {
  setAttendanceCourses (state, courses) {
    state.attendanceCourses = courses
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
